import { queryOptions } from '@tanstack/react-query';

import { adminControllerGetMe } from './generated';

export const meQueryOptions = () =>
  queryOptions({
    queryKey: ['me'] as const,
    queryFn: async () => {
      const { data } = await adminControllerGetMe({ throwOnError: true });
      return data;
    },
    staleTime: 60_000,
    retry: false, // 401/403 must propagate, not be retried
  });
